import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import actions from './actions'
import mutations from './mutations'
import alert from './modules/alert'
import auction from './modules/auction'
import grnfile from './modules/grnfile'
import farmer from './modules/farmer'
import session from './modules/session'
import role from './modules/role'
import permission from './modules/permission'
import cataloguefile from './modules/cataloguefile'
import estatecuredbrokerfile from './modules/estatecuredbrokerfile'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    alert,
    auction,
    grnfile,
    farmer,
    session,
    permission,
    role,
    cataloguefile,
    estatecuredbrokerfile

  },
  state,
  actions,
  mutations
})
